/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ok: NonNullable<unknown>, unmodified: NonNullable<unknown>, failed: NonNullable<unknown> }} Settings_Files_Toast_Reingest_Result_DescInputs */

const es_settings_files_toast_reingest_result_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_Result_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ok} actualizado(s), ${i?.unmodified} sin cambios, ${i?.failed} fallido(s).`)
};

const en_settings_files_toast_reingest_result_desc = /** @type {(inputs: Settings_Files_Toast_Reingest_Result_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ok} updated, ${i?.unmodified} unchanged, ${i?.failed} failed.`)
};

/**
* | output |
* | --- |
* | "{ok} updated, {unmodified} unchanged, {failed} failed." |
*
* @param {Settings_Files_Toast_Reingest_Result_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_toast_reingest_result_desc = /** @type {((inputs: Settings_Files_Toast_Reingest_Result_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Toast_Reingest_Result_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_toast_reingest_result_desc(inputs)
	return en_settings_files_toast_reingest_result_desc(inputs)
});
export { settings_files_toast_reingest_result_desc as "settings.files.toast.reingest_result_desc" }